// eslint-disable-next-line import/no-internal-modules
import * as viewer from "viewer/index";
export { viewer };
export default viewer;
